import { type ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { COMPANY } from './legalConfig'
import '@/styles/gg.css'
import '@/styles/landing2.css'
import '@/styles/legal.css'

interface LegalLayoutProps {
  title: string
  /** Omitted on pages that are not dated policies, such as Contact. */
  updated?: boolean
  children: ReactNode
}

/**
 * Shell for the standalone pages (privacy, terms, contact). Shares the public
 * site's nav and footer, with absolute links back to the home page since the
 * landing nav is anchor-driven.
 */
export function LegalLayout({ title, updated = true, children }: LegalLayoutProps) {
  return (
    <div className="gg lp legal" data-theme="light">
      <nav className="lp-nav">
        <div className="lp-wrap lp-nav__inner">
          <Link to="/" aria-label="GoGrov home">
            <img className="lp-wordmark" src="/brand/logo-horizontal-light.svg" alt="GoGrov" width={120} height={32} />
          </Link>
          <div className="lp-nav__links legal__links">
            <Link to="/">Home</Link>
            <Link to="/contact">Contact</Link>
            <Link to="/login" className="gg-btn gg-btn--amber lp-nav__cta">Sign in</Link>
          </div>
        </div>
      </nav>

      <main className="legal__main">
        <div className="lp-wrap legal__wrap">
          <span className="eyebrow eyebrow--accent">GoGrov</span>
          <h1 className="legal__title">{title}</h1>
          {updated && <p className="legal__updated">Last updated {COMPANY.lastUpdated}</p>}
          <div className="legal__body">{children}</div>
        </div>
      </main>

      <LegalFooter />
    </div>
  )
}

export function LegalFooter() {
  return (
    <footer className="lp-foot">
      <div className="lp-wrap">
        <div className="lp-foot__bottom legal__footbar">
          <span>© {new Date().getFullYear()} {COMPANY.legalName}. All rights reserved.</span>
          <span className="legal__footlinks">
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms</Link>
            <Link to="/contact">Contact</Link>
            <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>
          </span>
        </div>
      </div>
    </footer>
  )
}
